import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const applicationUpdatedModalComponent = {
  footer: {
    reloadPageButton: 'application-update-modal.footer.reload-page-button',
    root: 'application-update-modal.footer.root',
  },
  header: {
    h1: 'application-update-modal.header.h1',
    root: 'application-update-modal.header.root',
  },
  main: {
    p: 'application-update-modal.main.p',
    root: 'application-update-modal.main.root',
  },
  root: 'application-update-modal.root',
} as const satisfies ComponentLocatorMap;
